import React, {useEffect, useState} from "react";
import {addDays, addWeeks, endOfISOWeek, getDay, getISOWeek, getISOWeeksInYear, startOfYear,} from "date-fns";
import {Badge, Card, CardBody, Col, Container, Form, Row} from "react-bootstrap";
import { useTranslation } from "react-i18next";

const WeekSelector = ({onChange, selectAll = false }) => {
      const { t } = useTranslation();
    

    const [year, setYear] = useState(new Date().getFullYear());
    const [week, setWeek] = useState(getISOWeek(new Date()));
    const [weekDetails, setWeekDetails] = useState({});

    const [selectAllKey] = useState(-1);

  useEffect(() => {
    if (week !== selectAllKey) {
      updateWeekDetails(year, week);
    } else {
      updateSelectAllRange(year);
    }
  }, [year, week]);

    useEffect(() => {
        onChange && onChange(weekDetails);
    }, [weekDetails]);

    const updateWeekDetails = (year, week) => {
        const startOfWeekDate = addWeeks(findFirstDayOfFirstWeek(year), week - 1);
        const endOfWeekDate = endOfISOWeek(startOfWeekDate);

        setWeekDetails({
            week: week,
            year: year,
            startDate: startOfWeekDate,
            endDate: endOfWeekDate,
        });
    };

    const updateSelectAllRange = (year) => {
        const startDate = findFirstDayOfFirstWeek(year);
        const endDate = endOfISOWeek(new Date()); // end of current week
        setWeekDetails({
            week: "all",
            year,
            startDate,
            endDate,
            isSelectAll: true,
        });
    };

    const handleYearChange = (e) => {
        const year = parseInt(e.target.value);
        const weeks = weeksInYear(year);
        if(weeks.length < week) // If the selected week is not available in the selected year, set the last available week of the year.
        {
            setWeek(weeks[0]);
        }

        setYear(year);
    };

    const handleWeekChange = (e) => {
        setWeek(parseInt(e.target.value));
    };

    const yearsSince = (from, to = null) => {
        if (!to) {
            to = new Date().getFullYear();
        }

        const years = [];
        for (let i = from; i <= to; i++) {
            years.push(i);
        }
        return years.reverse();
    };

    const weeksInYear = (year) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const totalWeeks = getISOWeeksInYear(new Date(year, 0, 1));

        // If the year is the current year, limit the weeks to the current ISO week
        const maxWeek = year === currentYear ? getISOWeek(currentDate) : totalWeeks;

        const weekArray = Array.from({ length: maxWeek }, (_, i) => i + 1).reverse();

        if (selectAll) {
            return [selectAllKey, ...weekArray];
        }

        return weekArray;
    };


    function findFirstDayOfFirstWeek(year) {
        // Get the first day of the year
        const firstDayOfYear = startOfYear(new Date(year, 0, 1));

        // Initialize offset for the first Thursday
        let offset = 0;

        // Find the first Thursday (getDay returns 0 for Sunday, 4 for Thursday)
        while (getDay(addDays(firstDayOfYear, offset)) !== 4) {
            offset++;
        }


        // The start of the first 4-day week
        const startOfFirstWeek = addDays(firstDayOfYear, offset - (getDay(addDays(firstDayOfYear, offset)) - 1));

        return startOfFirstWeek;
    }

    return (
        <Container className="mt-4">
            <Card>
                <CardBody>
                    <Row>
                        <Col lg={2} md={4} sm={6}>
                            <Form.Select value={week} onChange={handleWeekChange}>
                                {weeksInYear(year).map((week) => (
                                    <option key={week} value={week}>
                                        {week === selectAllKey ? t("creditManagement.selectAll") : `Week ${week}`}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col lg={2} md={4} sm={6}>
                            <Form.Select
                                value={year}
                                onChange={handleYearChange}>
                                {yearsSince(2020).map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                            <Col className={'d-flex align-items-center'}>
                                <div className={'d-flex'}>
                                    <Badge bg="primary" className={'p-2'}>{weekDetails.startDate?.toDateString()}</Badge>
                                    <span className={'mx-2'}>-</span>
                                    <Badge bg="primary" className={'p-2'}>{weekDetails.endDate?.toDateString()}</Badge>
                                </div>
                            </Col>
                    </Row>
                </CardBody>
            </Card>
        </Container>
    );
};

export default WeekSelector;
